import React from 'react'

const InfoCiecleSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 19.401 19.401'
    >
      <path
        id='info-circle-svgrepo-com'
        d='M21.4,11.7A9.7,9.7,0,1,1,11.7,2,9.7,9.7,0,0,1,21.4,11.7Zm-9.7,5.578a.728.728,0,0,0,.728-.728V10.73a.728.728,0,1,0-1.455,0v5.82A.728.728,0,0,0,11.7,17.278Zm0-10.428a.97.97,0,1,1-.97.97A.97.97,0,0,1,11.7,6.85Z'
        transform='translate(-2 -2)'
        fill='#fff'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default InfoCiecleSvg
